import { AIJobStatus, FieldsetCompletion } from 'types'
import { UseQueryOptions } from 'react-query'
import { useFieldsetCompletionWithVoiceOrTone } from './useFieldsetCompletion'

interface Props {
  id: number
}

interface Options extends Omit<UseQueryOptions<{ fieldset_completion: FieldsetCompletion }>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollFieldsetCompletion = ({ id }: Props, options?: Options) => {
  return useFieldsetCompletionWithVoiceOrTone(
    { id },
    {
      refetchInterval: (data) => {
        if (
          data?.fieldset_completion &&
          [AIJobStatus.Successful, AIJobStatus.Failed].includes(data.fieldset_completion.status)
        ) {
          return false
        }

        return options?.intervalMs || 500
      },
      ...options,
    },
  )
}
